var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('default-layout'),_c('v-card',{staticClass:"overflow-hidden"},[_c('v-app-bar',{staticClass:"app-bar-style p-0 m-0",attrs:{"app":""}},[_c('menus-btn'),_c('v-spacer'),_c('p',[_vm._v(" "+_vm._s(_vm.$t('title.welcome'))+" ")]),_vm._v(" "),_c('p',{staticClass:"user-info"},[_vm._v(" "+_vm._s(_vm.label)+" ")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }